export default "__VITE_ASSET__yiYvWbZ9__";